module.exports = __webpack_public_path__ + "img/About the identification method of grabbed items.d4ea794c.png";